import React from 'react';

const Sucursales = (props) => {
    const { sucursales } = props;

    if (sucursales && sucursales.length > 0) {
        return (
            sucursales.map((item, index) =>
                <div key={item.Id} className="ui row stacked fluid">
                    {item.CasaMatriz} - {item.NombreComercial}
                </div>
            ));
    } else {
        return (<div >No hay sucursales relaciondas</div>);
    }

};

export default Sucursales;